// internal-deps
import { AnalyticsContextValue } from "@swiggy-private/checkout-core";

// constants
import { SCREEN_NAME, IMPRESSION_ACTIONS } from "../constants";

export const impressionApplyCouponGrouping = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    position: string,
    cartId: string,
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        context: JSON.stringify({ widgetSequence: position, cartId: cartId }),
        action: IMPRESSION_ACTIONS.IMPRESSION_COUPON_GROUPING,
    });
};

export const impressionBillTotalGrouping = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    position: string,
    cartId: string,
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        context: JSON.stringify({ widgetSequence: position, cartId: cartId }),
        action: IMPRESSION_ACTIONS.IMPRESSION_BILL_TOTAL_GROUPING,
    });
};

export const impressionTippingGrouping = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    position: string,
    cartId: string,
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        context: JSON.stringify({ widgetSequence: position, cartId: cartId }),
        action: IMPRESSION_ACTIONS.IMPRESSION_TIPPING_GROUPING,
    });
};

export const impressionDeliveryInstructionGrouping = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    position: string,
    cartId: string,
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        context: JSON.stringify({ widgetSequence: position, cartId: cartId }),
        action: IMPRESSION_ACTIONS.IMPRESSION_DELIVERY_INSTRUCTION_GROUPING,
    });
};

export const impressionApplyCouponGroupingActual = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    cartId: string,
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        context: JSON.stringify({ cartId: cartId }),
        action: IMPRESSION_ACTIONS.IMPRESSION_COUPON_GROUPING_ACTUAL,
    });
};

export const impressionBillTotalGroupingActual = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    cartId: string,
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        context: JSON.stringify({ cartId: cartId }),
        action: IMPRESSION_ACTIONS.IMPRESSION_BILL_TOTAL_GROUPING_ACTUAL,
    });
};

export const impressionTippingGroupingActual = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    cartId: string,
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        context: JSON.stringify({ cartId: cartId }),
        action: IMPRESSION_ACTIONS.IMPRESSION_TIPPING_GROUPING_ACTUAL,
    });
};

export const impressionDeliveryInstructionGroupingActual = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    cartId: string,
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        context: JSON.stringify({ cartId: cartId }),
        action: IMPRESSION_ACTIONS.IMPRESSION_DELIVERY_INSTRUCTION_GROUPING_ACTUAL,
    });
};
